<div class="overflowmobie">
    <app-header class="fixed-top"></app-header>

    <div *ngIf="this.globals.showData" class="container margin-top-container">

        <router-outlet></router-outlet>
    </div>
    <div *ngIf="this.globals.showNoInternet" class="container margin-top-container">
        <app-no-internet-connection class="container margin-top-container">

        </app-no-internet-connection>
    </div>
<app-footer class="footer-show"></app-footer>
</div>